import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6352b2bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-screen" }
const _hoisted_2 = { class: "live" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "LIVE", -1))
const _hoisted_4 = { class: "time" }
const _hoisted_5 = { class: "h" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "colon" }, ":", -1))
const _hoisted_7 = { class: "m" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["BackgroundImage"], { class: "bg" }),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString($setup.addZero($setup.hours)), 1),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, _toDisplayString($setup.addZero($setup.minutes)), 1)
      ])
    ]),
    _createVNode($setup["VimeoPlayer"], {
      class: "player myou",
      id: "739364512"
    }),
    _createVNode($setup["VimeoPlayer"], {
      class: "player dai",
      id: "739363739"
    }),
    _createVNode($setup["ChatPanel"], { class: "chat" })
  ]))
}